import { P2Manager } from "../../../LTGame/Physics/P2Manager";
import GlobalUnit from "../../common/GlobalUnit";
import LayerDefine from "../../common/LayerDefine";
import ItemBase from "./ItemBase";
export default class ItemBlack extends ItemBase {
    OnInit() {
        this.group = LayerDefine.Item;
        this.mask = LayerDefine.Player;
        this.CreateModel();
        this.CreateBody();
    }
    BeginContact(other) {
        P2Manager.instance.RemoveBody(this.body);
        GlobalUnit.game.player.JumpLevel(this.types[1], this.rootObj.transform);
    }
}
